<template>
  <div>
    <h3 class="title_header">公司管理</h3>
    <div class="from_header">
      <div class="seache_left">
        <div class="seache_item">
          <div class="label" style="width:80px;margin-left: 20px">企业名称：</div>
          <div class="search_input" style="width: 61%">
            <el-input v-model="searchForm.companyName" clearable placeholder="企业名称" />
          </div>
        </div>
        <div class="seache_item">
          <div class="label">联系人：</div>
          <div class="search_input">
            <el-input v-model="searchForm.contacts" clearable placeholder="联系人" />
          </div>
        </div>
        <div class="seache_item">
          <div class="label">联系方式：</div>
          <div class="search_input">
            <el-input v-model="searchForm.contactInformation" clearable placeholder="联系方式" />
          </div>
        </div>
        <div class="seache_item">
          <div class="label">套餐：</div>
          <div class="search_input">
            <el-select v-model="searchForm.productPid" placeholder="套餐" clearable>
              <el-option v-for="item in productData" :key="item.pid" :label="item.productName" :value="item.pid"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="seache_item">
          <div class="label">状态：</div>
          <div class="search_input">
            <el-select v-model="searchForm.companyStatus" placeholder="状态" clearable>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="停用" :value="2"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="seache_right">
        <el-button type="primary" @click="getCompanyList(1)">查询</el-button>
        <el-button type="primary" @click="dialogVisible = true" style="margin: 0px 0px 0px 10px">新增</el-button>
      </div>
    </div>

    <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%;align:center;margin-top: 5px">
      <el-table-column type="index"> </el-table-column>
      <el-table-column prop="companyName" label="企业名称"> </el-table-column>

      <el-table-column label="企业所在地">
        <template slot-scope="scope">
          {{ scope.row.provinceName }}{{ scope.row.cityName }}
        </template>
      </el-table-column>
      <el-table-column prop="contacts" label="联系人"> </el-table-column>
      <el-table-column prop="contactInformation" label="联系方式"> </el-table-column>
      <el-table-column prop="eMail" label="邮箱"> </el-table-column>
      <el-table-column prop="productName" label="套餐"> </el-table-column>
      <el-table-column label="权益有效期始" width="110">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.startDate) }}
        </template>
      </el-table-column>
      <el-table-column label="权益有效期至" width="110">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.endDate) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="50">
        <template slot-scope="scope">
          {{ scope.row.companyStatus == 1 ? '启用' : '停用' }}
        </template>
      </el-table-column>
      <el-table-column label="变更时间" width="110">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.updateDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="updateUserName" label="变更人" width="70"> </el-table-column>
      <el-table-column width="200" label="操作">
        <template slot-scope="scope">
          <el-button class="btn-text-edit" size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button class="btn-text-edit" size="mini" type="text" @click="deleteCompany(scope.row)">删除 </el-button>
          <el-button class="btn-text-edit" size="mini" type="text" @click="disableCompany(scope.row.pid)" v-if="scope.row.companyStatus === 1">停用 </el-button>
          <el-button class="btn-text-edit" size="mini" type="text" @click="enableCompany(scope.row.pid)" v-if="scope.row.companyStatus === 2">
            启用
          </el-button>
          <el-button class="btn-text-edit" size="mini" type="text" @click="goEmployeeList(scope.row)">员工管理 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination_bottom"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="parseInt(searchForm.pageNum)"
      :total="searchForm.total"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 20, 50, 100, 200]"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>

    <!--新增或编辑-->
    <el-dialog :title="isAdd ? '新增' : '修改'" :visible.sync="dialogVisible" :before-close="dialogCancel" width="800px">
      <el-form :model="dialogData" :rules="rules" ref="addRef">
        <el-form-item label="企业名称:" :label-width="formLabelWidth" prop="companyName">
          <el-input v-model="dialogData.companyName" autocomplete="off" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="所在地:" :label-width="formLabelWidth">
          <el-select v-model="dialogData.provinceCode" placeholder="请选择省" @change="regionChange(1)" clearable style="width: 100px">
            <el-option v-for="item in provinceData" :key="item.regionCode" :label="item.regionName" :value="item.regionCode"> </el-option>
          </el-select>
          省
          <el-select v-model="dialogData.cityCode" placeholder="请选择市" clearable style="width: 110px" @change="regionChange(2)">
            <el-option v-for="item in cityData" :key="item.regionCode" :label="item.regionName" :value="item.regionCode"> </el-option>
          </el-select>
          市
          <el-select v-model="dialogData.districtCode" placeholder="请选择区县" clearable style="width: 180px" @change="regionChange(3)">
            <el-option v-for="item in districtData" :key="item.regionCode" :label="item.regionName" :value="item.regionCode"> </el-option>
          </el-select>
          区/县
        </el-form-item>
        <el-form-item label="联系人:" :label-width="formLabelWidth" prop="contacts">
          <el-input v-model="dialogData.contacts" autocomplete="off" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="联系电话:" :label-width="formLabelWidth" prop="contactInformation">
          <el-input v-model="dialogData.contactInformation" autocomplete="off" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:" :label-width="formLabelWidth" prop="eMail">
          <el-input v-model="dialogData.eMail" autocomplete="off" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="套餐:" :label-width="formLabelWidth" style="text-align: left;" prop="productPid">
          <el-select v-model="dialogData.productPid" placeholder="套餐" clearable style="width: 600px">
            <el-option v-for="item in productData" :key="item.pid" :label="item.productName" :value="item.pid"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营业执照:" :label-width="formLabelWidth" prop="businessLicense">
          <el-upload action list-type="picture-card" :show-file-list="false" :http-request="uploadObs" :auto-upload="true">
            <div v-if="dialogData.businessLicense" style="width: 100%;height: 100%">
              <img :src="dialogData.businessLicense" style="width: 100%;height: 100%" />
            </div>
            <i slot="default" class="el-icon-plus" v-else></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="权益有效期始:" :label-width="formLabelWidth" prop="startDate">
          <el-date-picker v-model="dialogData.startDate" type="date" value-format="timestamp" placeholder="选择日期" style="width: 600px"> </el-date-picker>
        </el-form-item>
        <el-form-item label="权益有效期至:" :label-width="formLabelWidth" prop="endDate">
          <el-date-picker v-model="dialogData.endDate" type="date" value-format="timestamp" placeholder="选择日期" style="width: 600px"> </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel()">取 消</el-button>
        <el-button type="primary" @click="dialogAffirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/dataStorage.js'
import ObsClient from 'esdk-obs-browserjs/src/obs'
import Config from '@/utils/app.config'

export default {
  data() {
    return {
      searchForm: {
        companyName: '',
        companyStatus: '',
        contactInformation: '',
        contacts: '',
        pageNum: 1,
        pageSize: 10,
        total: null,
        productPid: '',
      },
      productData: [], //产品列表
      tableData: [], //数据date

      isAdd: true,
      dialogVisible: false,
      dialogData: {},
      rules: {
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactInformation: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        eMail: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],

        startDate: [{ required: true, message: '请输入选择权益开始日期', trigger: 'blur' }],
        endDate: [{ required: true, message: '请输入选择权益结束日期', trigger: 'blur' }],
      },
      formLabelWidth: '130px',
      provinceData: [], //省
      cityData: [], //市
      districtData: [], //区/县

      //文件上传
      disabled: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getProductList()
      this.getCompanyList()
      this.getRegion('', 1)
    },

    /**
     * 获取产品列表
     */
    getProductList() {
      this.$post(this.$url.公司产品表, {})
        .then((res) => {
          this.productData = res
        })
        .catch((err) => {})
    },
    /**
     * 获取公司列表
     * @param val 当前页
     */
    getCompanyList(val) {
      if (val == 1) this.searchForm.page = 1
      this.$post(this.$url.公司列表, this.searchForm)
        .then((res) => {
          this.tableData = res.list
          this.searchForm.pageNum = parseInt(res.pageNum)
          this.searchForm.pageSize = parseInt(res.pageSize)
          this.searchForm.total = parseInt(res.total)
        })
        .catch((err) => {
          Promise.reject(err)
        })
    },

    /**
     * 获取省市区信息
     * @param regionCode 父级code
     * @param type 赋值类型 1 = provinceData；2 = cityData；3 = districtData
     */
    getRegion(regionCode, type) {
      this.$post(this.$url.查询省市区, { regionCode: regionCode })
        .then((res) => {
          if (type === 1) {
            this.provinceData = res
          } else if (type === 2) {
            this.cityData = res
          } else if (type === 3) {
            this.districtData = res
          }
        })
        .catch((err) => {
          Promise.reject(err)
        })
    },

    /**
     * 地区级联选择框发生变更
     * @param type 1 = 省份变更；2 = 市变更；3 = 地区变更
     */
    regionChange(type) {
      if (type === 1) {
        this.cityData = []
        this.districtData = []
        this.getRegion(this.dialogData.provinceCode, 2)

        this.dialogData.cityCode = ''
        this.dialogData.districtCode = ''

        this.dialogData.provinceName = this.getRegionByCode(this.dialogData.provinceCode, this.provinceData)
      } else if (type === 2) {
        this.dialogData.districtCode = ''
        this.districtData = []
        this.getRegion(this.dialogData.cityCode, 3)

        this.dialogData.cityName = this.getRegionByCode(this.dialogData.cityCode, this.cityData)
      } else if (type === 3) {
        this.dialogData.districtName = this.getRegionByCode(this.dialogData.districtCode, this.districtData)
      }
      this.$forceUpdate()
    },
    /**
     * 从data中朝招code = code的item
     * @param code
     * @param data
     */
    getRegionByCode(code, data) {
      for (let index in data) {
        let item = data[index]
        if (item.regionCode === code) {
          return item.regionName
        }
      }
    },

    dialogCancel() {
      this.$refs['addRef'].resetFields()
      this.dialogVisible = false
      this.dialogTitle = true
      this.dialogData = {
        provinceCode: '',
        cityCode: '',
        districtCode: '',
      }
    },

    //打开编辑弹窗
    edit(row) {
      this.isAdd = false
      this.dialogData = row
      //获取市和地区数据，用于回显
      this.getRegion(this.dialogData.provinceCode, 2)
      this.getRegion(this.dialogData.cityCode, 3)
      this.dialogVisible = true
    },
    /**
     * 禁用公司
     * @param pid 公司ID
     */
    disableCompany(pid) {
      this.$post(this.$url.公司禁用, { pid: pid }, true)
        .then((res) => {
          this.getCompanyList(1)
        })
        .catch((err) => {
          Promise.reject(err)
        })
    },
    /**
     * 启用公司
     * @param pid 公司ID
     */
    enableCompany(pid) {
      this.$post(this.$url.公司启用, { pid: pid }, true)
        .then((res) => {
          this.getCompanyList(1)
        })
        .catch((err) => {
          Promise.reject(err)
        })
    },
    /**
     * 删除公司
     * @param pid 公司ID
     */
    deleteCompany(row) {
      this.$confirm('是否删除【' + row.companyName + '】？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '返回',
      })
        .then(() => {
          this.$post(this.$url.删除公司, { pid: row.pid }, true)
            .then((res) => {
              this.getCompanyList(1)
            })
            .catch((err) => {
              Promise.reject(err)
            })
        })
        .catch((action) => {})
    },
    /**
     * 前往员工管理列表
     * @param pid
     */
    goEmployeeList(row) {
      this.$router.push({
        name: 'companyEmployeeList',
        query: { pid: row.pid, companyName: row.companyName, productName: row.productName },
      })
    },

    //编辑或添加
    dialogAffirm() {
      this.$refs['addRef'].validate((valid) => {
        if (valid) {
          let url
          if (this.isAdd) {
            url = this.$url.添加公司
          } else {
            url = this.$url.更新公司
          }
          this.$post(url, this.dialogData, true)
            .then((res) => {
              this.$message.success('成功')
              this.dialogCancel()
              this.getCompanyList(1)
            })
            .catch((err) => {
              Promise.reject(err)
            })
        } else {
          return false
        }
      })
    },

    //上传文件
    uploadObs(file) {
      // 创建ObsClient实例
      var obsClient = new ObsClient({
        access_key_id: Config.obsAccessKeyId,
        secret_access_key: Config.obsSecretAccessKey,
        server: Config.obsServer,
      })

      this.$post(this.$url.获取UUID, {})
        .then((res) => {
          let loading = this.$loading({
            lock: true,
            text: '上传中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          let thit = this
          obsClient.putObject(
            {
              Bucket: Config.obsBucket, // 桶名
              Key: res, // 路径 + 文件名
              SourceFile: file.file,
            },
            function(err, result) {
              loading.close()
              if (err) {
                thit.$message({ message: '上传失败', type: 'error' })
              } else {
                thit.$message({ message: '上传成功', type: 'success' })
                thit.dialogData.businessLicense = Config.obsBaseUrl + res
                thit.$forceUpdate()
              }
            }
          )
        })
        .catch((err) => {
          Promise.reject(err)
        })
    },

    getToken() {
      return getToken()
    },

    handleCurrentChange(val) {
      this.searchForm.pageNum = val
      this.getCompanyList()
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.getCompanyList()
    },
  },
}
</script>

<style scoped lang="less">
.title_header {
  text-align: left;
  padding: 20px 20px 10px 20px;
  background-color: #ffffff;
  margin-bottom: 3px;
}

.pagination_bottom {
  text-align: right;
  background-color: #ffffff;
  padding: 22px 20px;
}

.from_header {
  background-color: #ffffff;
  width: 100%;
  height: 60px;
  line-height: 60px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;

  .seache_left {
    width: 80%;
    height: 100%;
    display: inline-block;

    .seache_item {
      width: 260px;
      display: inline-block;
      margin-right: 20px;

      .label {
        display: inline-block;
        width: 35%;
        text-align: right;
      }

      .search_input {
        display: inline-block;
        width: 65%;
      }
    }
  }

  .seache_right {
    width: 18%;
    height: 100%;
    display: inline-block;
    text-align: right;
  }
}
</style>
